import 'arrayq';

import { PureConnect, React } from '../../react';
import { ICategory } from '../../types';
import { categoriesBatch } from './resource';

import cx from './style.less';
import { Btn } from '../../react-toolbox-redesign/button';
import { Modal } from '../modal';
import FocusLockFocusGuard from '../../focuslock/focuslockext';

export default PureConnect('CategoriesBatchDeleteModal')(
    (state) => ({
        deleting: categoriesBatch.selectors.deleting(state),
        items: categoriesBatch.selectors.sourceItems(state),
    }),
    (dispatch) => ({
        onCancel: () => dispatch(categoriesBatch.actions.DELETE_CANCEL({ })),
        onSave: (items: ICategory[]) => dispatch(categoriesBatch.actions.DELETE_CONTINUE({ items })),
    }),
    ({ deleting, items, onCancel, onSave }) => {

        return (
            <Modal onEscKeyDown={onCancel} 
                visible={deleting} 
                type="smallsize1"
                backdrop={true}
            >                   
                <div className={cx(!(deleting) ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!(deleting)} aria-labelledby= "Verwijder categorieën">
                    <FocusLockFocusGuard disabled={!(deleting)}>  
                        <CategoriesBatchDeleteArea />
                        <CategoriesBatchDeleteButtons />
                    </FocusLockFocusGuard>
                </div>
            </Modal>     
        );
    });

export const CategoriesBatchDeleteArea = PureConnect('CategoriesBatchDeleteArea')(
        (state) => ({
            deleting: categoriesBatch.selectors.deleting(state),
            items: categoriesBatch.selectors.sourceItems(state),
        }),
        (dispatch) => ({}),
        ({ deleting, items }) => {
            return (           
                    <div className={cx(!(deleting) ? 'wcag-invisible' : '', 'warning')}  aria-hidden={!(deleting)} aria-labelledby= "Verwijder categorieën">
                        <div className={cx('warning-container')}>
                            <div className={cx('warning-title')}>Categorieën verwijderen</div>
                            <div className={cx('warning-content')}>
                                <p>
                                    U staat op het punt <span className={cx('name-label')}>{items.length} categorie{items.length>1?'ën':''}</span> te verwijderen. 
                                </p>
                                <p className={cx('medium')}>
                                    Deze actie kunt u niet ongedaan maken.
                                </p>
                            </div>
                        </div>
                    </div>          
            );
        });

export const CategoriesBatchDeleteButtons = PureConnect('CategoriesBatchDeleteButtons')(
            (state) => ({
                deleting: categoriesBatch.selectors.deleting(state),
                items: categoriesBatch.selectors.sourceItems(state),
            }),
            (dispatch) => ({
                onCancel: () => dispatch(categoriesBatch.actions.DELETE_CANCEL({ })),
                onSave: (items: ICategory[]) => dispatch(categoriesBatch.actions.DELETE_CONTINUE({ items })),
            }),
            ({ deleting, items, onCancel, onSave }) => {
                return (           
                        <div className={cx('bottom-panel', 'not-absolutely', !(deleting) ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!(deleting)} aria-labelledby= "Verwijder notitie">
                            <div className={cx('bottom-buttons-container')}>
                                <div className={cx('buttons-container', !(deleting)? 'wcag-invisible' : '' )}>
                                    <Btn 
                                        type="button" 
                                        className={'btn'} 
                                        extraClassNames={'secondary-btn'}
                                        aria-label={'Annuleren van het verwijderen'}
                                        aria-haspopup={false}                        
                                        tabIndex={0} 
                                        onKeyDown={(evt: any) => onCancel()}                           
                                        onClick={(evt: any) => onCancel()}                                                                                             
                                        >
                                            <span>Annuleren</span>
                                    </Btn>
            
                                    <Btn 
                                        type="button" 
                                        className={'btn'} 
                                        aria-label={'Verwijderen van categorieën'}
                                        aria-haspopup={false}                        
                                        tabIndex={0} 
                                        disabled={false} 
                                        onKeyDown={(evt: any) => onSave(items)}                           
                                        onClick={(evt: any) => onSave(items)}                                                                                       
                                        >
                                            <span>Verwijderen</span>
                                    </Btn>
                                </div>                
                            </div>
                        </div>          
                );
            });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/categories/batchDeleteModal.tsx